import { Spinner } from '@journ/ui/spinner'
import { Camera } from '@phosphor-icons/react'
import { useRef, useState } from 'react'
import { UserAvatar } from '@/components/user-avatar'
import { useIntlayer } from 'react-intlayer'
import { session$ } from '@/features/auth/store'
import { useMemberActions } from '../hooks/use-member-actions'
import { refreshMembersList } from '../store'

type Props = {
	memberId: string
	fullName: string
	avatarUrl: string | null
}

const MemberAvatarField = ({ memberId, fullName, avatarUrl }: Props) => {
	const content = useIntlayer('hr-page')
	const { uploadAvatar } = useMemberActions()
	const inputRef = useRef<HTMLInputElement>(null)
	const [url, setUrl] = useState(avatarUrl)
	const [uploading, setUploading] = useState(false)

	const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0]
		e.target.value = ''
		if (!file) return
		setUploading(true)
		try {
			const member = await uploadAvatar(memberId, file)
			setUrl(member.avatarUrl)
			const user = session$.user.get()
			if (user && user.id === memberId) {
				session$.user.set({ ...user, avatarUrl: member.avatarUrl })
			}
			refreshMembersList()
		} finally {
			setUploading(false)
		}
	}

	return (
		<div className='mb-6 flex items-center gap-4'>
			<button
				type='button'
				onClick={() => inputRef.current?.click()}
				className='group relative size-16 shrink-0 overflow-hidden rounded-full border border-border'
			>
				<UserAvatar name={fullName} avatarUrl={url} size='xl' className='size-full' />
				<span className='absolute inset-0 flex items-center justify-center bg-foreground/40 opacity-0 transition-opacity group-hover:opacity-100'>
					{uploading ? (
						<Spinner size={18} className='text-background' />
					) : (
						<Camera className='size-5 text-background' />
					)}
				</span>
			</button>
			<div className='text-xs text-878787'>{content.form.avatarHint}</div>
			<input ref={inputRef} type='file' accept='image/*' className='hidden' onChange={handleChange} />
		</div>
	)
}

export { MemberAvatarField }
